module.exports = __webpack_public_path__ + "media/images/photos/luxembourg-e75366e30369de6ea213a4d3224b9bad.jpg";